import * as Yup from "yup"

const RepresentativesValidation = {

}

export default Yup.object()
    .shape(
        RepresentativesValidation,
    )
    .required()
